import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, ArrowUp } from '@phosphor-icons/react';
interface CaseStudyLink {
  category: string;
  title: string;
  slug: string;
}
interface CaseStudyNavigationProps {
  previousCase?: CaseStudyLink;
  nextCase?: CaseStudyLink;
  /** Accent color for the back-to-top affordance. Defaults to a neutral slate. */
  accent?: string;
}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
export function CaseStudyNavigation({
  previousCase,
  nextCase,
  accent = '#0f172a'
}: CaseStudyNavigationProps) {
  return <nav aria-label="Case study navigation" className="px-6 sm:px-12 md:px-16 lg:px-24 max-w-5xl mx-auto w-full mt-24 sm:mt-32 mb-12" data-id="element-105">
      {/* Back to top */}
      <div className="flex justify-center mb-12 sm:mb-16" data-id="element-106">
        <button type="button" onClick={scrollToTop} className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 transition-colors" style={{
        fontFamily: "'Ronzino', sans-serif"
      }} data-id="element-107">
          <span className="flex items-center justify-center w-9 h-9 rounded-full border border-slate-200 transition-colors group-hover:border-slate-400" style={{
          color: accent
        }} data-id="element-108">
            <ArrowUp className="w-4 h-4 transition-transform group-hover:-translate-y-0.5" data-id="element-109" />
          </span>
          Back to top
        </button>
      </div>

      {/* Prev / Next */}
      {(previousCase || nextCase) && <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200 rounded-2xl overflow-hidden" data-id="element-110">
          {/* Previous */}
          {previousCase ? <Link to={`/case-study/${previousCase.slug}`} onClick={() => window.scrollTo(0, 0)} className="group bg-white p-6 sm:p-8 hover:bg-slate-50 transition-colors flex flex-col gap-2" data-id="element-111">
              <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-400" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-112">
                <ArrowLeft className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-0.5" data-id="element-113" />
                Previous
              </span>
              <span className="text-lg sm:text-xl font-light text-slate-900 leading-snug" style={{
          fontFamily: "'Gefika', sans-serif"
        }} data-id="element-114">
                {previousCase.title}
              </span>
              <span className="text-xs uppercase tracking-[0.15em] text-slate-400" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-115">
                {previousCase.category}
              </span>
            </Link> : <div className="hidden sm:block bg-white" aria-hidden="true" data-id="element-116" />}

          {/* Next */}
          {nextCase ? <Link to={`/case-study/${nextCase.slug}`} onClick={() => window.scrollTo(0, 0)} className="group bg-white p-6 sm:p-8 hover:bg-slate-50 transition-colors flex flex-col gap-2 sm:items-end sm:text-right" data-id="element-117">
              <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-400" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-118">
                Next
                <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" data-id="element-119" />
              </span>
              <span className="text-lg sm:text-xl font-light text-slate-900 leading-snug" style={{
          fontFamily: "'Gefika', sans-serif"
        }} data-id="element-120">
                {nextCase.title}
              </span>
              <span className="text-xs uppercase tracking-[0.15em] text-slate-400" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-121">
                {nextCase.category}
              </span>
            </Link> : <div className="hidden sm:block bg-white" aria-hidden="true" data-id="element-122" />}
        </div>}
    </nav>;
}